import { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Alert from 'react-bootstrap/Alert';
import './Register.css';
import logo from "../image/Logspintoss.png";

const Errors = ({ errors }) => {
  if (!errors || !errors.length) return null;
  return (
    <div className="mb-3">
      {errors.map((el, i) => (
        <Alert key={i} variant="danger">{el}</Alert>
      ))}
    </div>
  );
};

const Register = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [matricule, setMatricule] = useState('');
  const [localisation, setLocalisation] = useState('');
  const [fonction, setFonction] = useState('');
  const [role, setRole] = useState('user');
  const [locations, setLocations] = useState([]);
  const [loadingLocations, setLoadingLocations] = useState(true);
  const [errors, setErrors] = useState([]);

  const navigate = useNavigate();

  // 🔹 Charger toutes les localisations
  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const res = await axios.get('/api/locationspin/getAllLocations');
        setLocations(res.data);
      } catch (err) {
        console.error("❌ Erreur chargement des emplacements :", err);
      } finally {
        setLoadingLocations(false);
      }
    };
    fetchLocations();
  }, []);

  useEffect(() => {
  if (!locations.length) return;
  
  if (role === "userspintoss") {
    const twin = locations.find((loc) => loc.name.toLowerCase() === "twin park");
    if (twin) setLocalisation(twin._id);
  
  } else {
    setLocalisation('');
  }
}, [role, locations]);

  const handleRegister = async (e) => {
    e.preventDefault();
    setErrors([]); // Reset erreurs

    try {
      const res = await axios.post('/api/auth/SignUp', {
        name,
        email,
        password,
        matricule,
        localisation,
        fonction,
        role,
      });

      console.log("Inscription réussie :", res.data);
      navigate("/AllUser");
    } catch (error) {
      console.log("Erreur Register :", error.response?.data || error.message);

      if (error.response?.data?.errors) {
        setErrors(error.response.data.errors.map(e => e.msg));
      } else {
        setErrors([error.response?.data?.msg || "Une erreur est survenue."]);
      }
    }
  };

  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 w-100 register-background">
      <div className="register-container shadow rounded p-5 text-center">
        <img src={logo} alt="Logo" className="mb-4" style={{ width: '180px' }} />

        <Errors errors={errors} />

        <Form onSubmit={handleRegister}>
          <div className="row">
            <div className="col-md-4">
              <Form.Group className="mb-3">
                <Form.Label>Nom</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Votre nom"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="mb-3">
                <Form.Label>Matricule</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Matricule"
                  value={matricule}
                  onChange={(e) => setMatricule(e.target.value)}
                  required
                />
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Votre email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Form.Group>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4">
              <Form.Group className="mb-3">
                <Form.Label>Mot de passe</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Votre mot de passe"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="mb-3">
                <Form.Label>Rôle</Form.Label>
                <Form.Select
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                >
                  <option value="useradmin">Utilisateur</option>
                  <option value="admin">Administrateur</option>
                  <option value="userspintoss">Spintoss</option>
                 
                </Form.Select>
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="mb-3">
                <Form.Label>Fonction</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Fonction"
                  value={fonction}
                  onChange={(e) => setFonction(e.target.value)}
                />
              </Form.Group>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4">
              <Form.Group className="mb-4">
                <Form.Label>Localisation</Form.Label>

                {loadingLocations ? (
                  <Form.Control type="text" value="Chargement..." disabled />
                ) : (
                  <Form.Select
                    value={localisation}
                    onChange={(e) => setLocalisation(e.target.value)}
                    disabled={role !== "userspintoss"} // Grisé pour tout sauf Twin Park
                  >
                    <option value="">-- Sélectionnez une localisation --</option>
                    {locations.map((loc) => (
                      <option key={loc._id} value={loc._id}>{loc.name}</option>
                    ))}
                  </Form.Select>
                )}
              </Form.Group>
            </div>
          </div>

          <Button variant="primary" type="submit">
            Enregistrer
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default Register;
